'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('@wix/wixrest-utils/dist/I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _restaurantsI18nJs = require('@wix/restaurants-i18n-js');

var _NumberFormatUtils = require('@wix/wixrest-utils/dist/NumberFormatUtils');

var _NumberFormatUtils2 = _interopRequireDefault(_NumberFormatUtils);

var _AvailabilityPrinter = require('@wix/wixrest-utils/dist/AvailabilityPrinter');

var _AvailabilityPrinter2 = _interopRequireDefault(_AvailabilityPrinter);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var I18nProvider = function (_React$Component) {
    (0, _inherits3.default)(I18nProvider, _React$Component);

    function I18nProvider(props) {
        (0, _classCallCheck3.default)(this, I18nProvider);

        var _this = (0, _possibleConstructorReturn3.default)(this, (I18nProvider.__proto__ || (0, _getPrototypeOf2.default)(I18nProvider)).call(this, props));

        var shouldRender = !!props.localeData /* && !props.asyncGlobalsRequired*/;
        _this.state = { shouldRender: shouldRender };
        _this.i18n = _I18n2.default;

        _this.updateI18n = _this.updateI18n.bind(_this);
        _this.handleSideEffects = _this.handleSideEffects.bind(_this);

        if (shouldRender) {
            _this.handleSideEffects(props);
            _this.updateI18n(props);
        }
        return _this;
    }

    (0, _createClass3.default)(I18nProvider, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.localeData !== this.props.localeData) {
                this.updateI18n(nextProps);
            }
        }
    }, {
        key: 'updateI18n',
        value: function updateI18n(props) {
            var _this2 = this;

            if (!props.localeData) {
                return;
            }

            var prepareGlobals = this.prepareGlobals(props.localeData);
            if (prepareGlobals) {
                prepareGlobals.then(function () {
                    return _this2.handleSideEffects(props);
                }).then(function () {
                    return _this2.forceUpdate();
                });
            } else {
                this.handleSideEffects(props);
            }
        }
    }, {
        key: 'handleSideEffects',
        value: function handleSideEffects(props) {
            this.i18n.impl = new _restaurantsI18nJs.I18N(props.localeData);

            _NumberFormatUtils2.default.init(this.i18n.getLocale(), props.Intl);
            _AvailabilityPrinter2.default.init({ i18n: this.i18n });
            if (!props.skipLocaleSideEffect) {
                _restaurantsI18nJs.I18nUtils.fixMomentDefinitions(this.i18n.getLocale());
            }

            if (this.state.shouldRender !== !!props.localeData) {
                this.setState({ shouldRender: !!props.localeData });
            }
        }
    }, {
        key: 'prepareGlobals',
        value: function prepareGlobals() {
            return null;
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                i18n: this.i18n.impl,
                numberFormatUtils: _NumberFormatUtils2.default,
                availabilityPrinter: _AvailabilityPrinter2.default,
                moment: _moment2.default,
                contentProps: {
                    appHeader: this.props.appHeader,
                    appTokens: this.props.appTokens
                }
            };
        }
    }, {
        key: 'render',
        value: function render() {
            return this.state.shouldRender && this.props.children;
        }
    }]);
    return I18nProvider;
}(_react2.default.Component);

I18nProvider.displayName = 'I18nProvider';
I18nProvider.propTypes = {
    localeData: _propTypes2.default.object,
    skipLocaleSideEffect: _propTypes2.default.bool,
    Intl: _propTypes2.default.object.isRequired,
    appHeader: _propTypes2.default.string,
    appTokens: _propTypes2.default.object
};
I18nProvider.defaultProps = {
    Intl: Intl,
    appHeader: '',
    appTokens: {}
};
I18nProvider.childContextTypes = {
    i18n: _propTypes2.default.object,
    numberFormatUtils: _propTypes2.default.object,
    availabilityPrinter: _propTypes2.default.object,
    moment: _propTypes2.default.func,
    contentProps: _propTypes2.default.object
};

exports.default = I18nProvider;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-components-css-modules/dist/shared/I18nProvider/I18nProvider.js
// module id = 666
// module chunks = 0